/**
 * Scene component extracted from HomefixScene
 */

class HomefixSceneComponent extends ScriptComponent {
    onAttach() {
        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);
        this.sceneComponent.setStyling(this.getBackgroundStyles());
        this.sceneComponent.setBundles(this.listBundles());

        this.node.getPreferredBundles = function () {
            return ["main"];
        };
    }

    onDestruct() {
        if (Homefix.currentHomefix) {
            Homefix.currentHomefix.stop();
            Homefix.currentHomefix = undefined;
        }
    }

    onSceneLoaded() {
        this.homefix = new Homefix();

        this.homefix.on("animateNewTask", this.animateNewTask.bind(this), this.node);

        this.innerMap = new Map2dInnerView(this.homefix.map);
        this.mapView = this.innerMap.wrapWithScroll(this.mapPositionChanged.bind(this));
        this.node.addChild(this.mapView);

        this.setInitialScroll(this.homefix.map.getFocusCell() || this.homefix.getInitialScroll());
        this.onResize();

        this.node.runAction(new cc.RepeatForever(new cc.Sequence(
            new cc.DelayTime(5),
            cleverapps.effects.fireAction("location.city.loop"),
            new cc.DelayTime(5)
        )));

        cleverapps.focusManager.registerControl("finger_control", this.node.createListener((visible) => {
            if (visible) {
                this.createFinger();
            }
        }));

        if (cleverapps.git) {
            cleverapps.git.changeFolders([GitManager.FOLDERS.UNIT_ANCHORS]);
        }
    }

    setInitialScroll(cell) {
        let scrollCell = this.innerMap.getCell(cell.x, cell.y);
        scrollCell = scrollCell ? this.mapView.normalizePoint(this.mapView.outOfBoundariesVector(scrollCell)) : this.mapView.getContainerPosition();

        this.mapView.scrollToPoint(scrollCell);
    }

    onResize() {
        if (this.mapView) {
            const bgSize = cleverapps.resolution.getBgSize();
            const safePadding = cleverapps.resolution.getSafePadding();
            this.mapView.setContentSize(bgSize.width, bgSize.height);
            this.mapView.setAlignment(bgSize.width / 2 - safePadding.left, bgSize.height / 2 - safePadding.bottom);

            this.mapView.zoomHandler.setZoom(this.mapView.zoom, true);
        }

        if (this.homefix && this.homefix.shownUnit) {
            this.homefix.zoomInToUnit(this.homefix.shownUnit, true);
        }
    }

    hasOrangery() {
        return !!(Map2d.currentMap.orangery && !cleverapps.gameModes.noControls);
    }

    buildOrangery() {
        return new OrangeryView(Map2d.currentMap.orangery);
    }

    getOrangeryControlName() {
        return Map2d.currentMap.orangery.getControlName();
    }

    buildPlayButton() {
        this.playButton = new PlayButtonView({
            isSmall: true,
            hard: true
        });
        return this.playButton;
    }

    createFinger() {
        const unit = this.homefix.canBeUpgraded() && this.homefix.getCurrentFurniture().unit;
        if (!unit) {
            return;
        }
        let unitView = unit.onGetView();
        if (unitView && unit.findComponent(Invisible)) {
            unitView = unitView.getAdditionalView("homeTask");
        }

        FingerView.hintTap(unitView || this.playButton);
    }

    animateNewTask(furniture, f) {
        new NewTaskAnimation(furniture, this.node, f);
    }

    onPlayIntro(callback, silent) {
        cleverapps.focusManager.compound(callback, [
            function (f) {
                if (silent) {
                    f();
                    return;
                }

                HomefixIntroAnimation.show(f);
            },
            function (f) {
                this.homefix.showUp(f);
            }.bind(this)
        ]);

        return true;
    }

    mapPositionChanged() {
        if (!this.mapView) {
            return;
        }

        const styles = this.sceneComponent.styling;
        if (!styles.parallax || !this.node.background) {
            return;
        }

        const scale = this.mapView.zoom - this.mapView.zoomHandler.minZoom;
        const safePadding = cleverapps.resolution.getSafePadding();
        const normalizedScale = Math.max(1.1 * this.node.height / this.node.background.height, 1.25 + HomefixSceneComponent.PARALLAX_FACTOR * scale) + 0.001 * (safePadding.top + safePadding.bottom);
        this.node.background.setScale(normalizedScale);

        const scroll = this.mapView.getScrollPercent();
        const normalizedScroll = {
            x: 2 * (scroll.x - 0.5),
            y: 2 * (scroll.y - 0.5)
        };

        let x = this.node.width / 2 + HomefixSceneComponent.PARALLAX_FACTOR * this.node.width * normalizedScroll.x * (1 + scale);
        let y = this.node.height / 2 + HomefixSceneComponent.PARALLAX_FACTOR * this.node.height * normalizedScroll.y * (1 + scale);

        if (styles.parallax.hideHorizon) {
            x = this.node.width * (0.5 + 0.1 * normalizedScroll.x);
            y = this.node.height * (1.2 + 0.9 * normalizedScroll.y);
        }

        this.node.background.setAlignment(x - safePadding.left, y - safePadding.bottom);
    }

    getBackgroundStyles() {
        const location = cleverapps.meta.getSelectedLocation();
        const bundleId = location.locationConfig.unknown ? "unknown" : location.locationId;
        const image = bundles.map_background.frames[`background_${bundleId}_png`] || bundles.map_background.frames.background_png;
        return { scale9: image };
    }

    listBundles() {
        const result = [];

        const location = cleverapps.meta.getSelectedLocation();
        const bundleId = location.locationConfig.unknown ? "unknown" : location.locationId;

        result.push(location.locationConfig.locationBundleId);
        result.push(Map2d.getTilesTexture(bundleId));
        result.push(Map2d.getUnitsTexture(bundleId));

        return result;
    }
}

HomefixSceneComponent.PARALLAX_FACTOR = 1;

Prefab.registerComponent("HomefixSceneComponent", HomefixSceneComponent);
